const scrollTableToLeft = () => {
  const tableElement = document.getElementById('table-component__container');
  tableElement?.scrollTo({ left: 0 });
};

export default scrollTableToLeft;
